import React, { Component } from "react";

const GhanaIcon = ({width,height,fill,...rest}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 20"
      fill="none"
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.93068 1.03452L8.98761 1.03285L9.0432 1.02049L10.3664 0.726443L11.6238 9.60748V14.8636V15.0571L11.7369 15.2141L12.3238 16.0296L3.94949 19.3404L0.803119 17.6747L0.608107 12.7994L3.08718 9.5228L3.23488 9.32758L3.20386 9.08475L2.20075 1.23246L8.93068 1.03452Z"
        stroke={fill}
        strokeWidth="1.2"
      />
    </svg>
  );
};

GhanaIcon.defaultProps = {
  width: 14,
  height: 20,
  fill: "black",
};

export default GhanaIcon;
